import { CoursesModelsType } from '@/utils/trees/TreeCourses';
import TreeItem from '@/components/shared/TreeItem';
import { mountKey } from '@/utils/courses';
import Lesson from '@/models/Lesson';

type CourseLessonTreeProps = {
  item: Lesson;
  parentId: string;
};

export default function CourseLessonTree({
  item,
  parentId,
}: CourseLessonTreeProps) {
  const type: CoursesModelsType = 'lesson';
  const key = mountKey({ id: item.id, type });
  const treeItem = { id: item.id, name: item.name };
  return (
    <TreeItem objKey={key} type={type} parentId={parentId} item={treeItem} />
  );
}
